var map = {
	"./$pac.svg": [
		7275,
		7275
	],
	"./0xbtc.svg": [
		18224,
		18224
	],
	"./1inch.svg": [
		79752,
		79752
	],
	"./2give.svg": [
		53900,
		53900
	],
	"./UNFI.svg": [
		71733,
		71733
	],
	"./aave.svg": [
		60062,
		60062
	],
	"./abt.svg": [
		57494,
		57494
	],
	"./acm.svg": [
		47696,
		47696
	],
	"./act.svg": [
		14025,
		14025
	],
	"./actn.svg": [
		4589,
		4589
	],
	"./ada.svg": [
		82073,
		82073
	],
	"./add.svg": [
		66420,
		66420
	],
	"./adx.svg": [
		38048,
		38048
	],
	"./ae.svg": [
		53513,
		53513
	],
	"./aeon.svg": [
		60322,
		60322
	],
	"./aeur.svg": [
		69944,
		69944
	],
	"./agi.svg": [
		82056,
		82056
	],
	"./agrs.svg": [
		18682,
		18682
	],
	"./aion.svg": [
		79606,
		79606
	],
	"./algo.svg": [
		75610,
		75610
	],
	"./alpha.svg": [
		87465,
		87465
	],
	"./amb.svg": [
		81825,
		81825
	],
	"./amp.svg": [
		54803,
		54803
	],
	"./ampl.svg": [
		43581,
		43581
	],
	"./ankr.svg": [
		15533,
		15533
	],
	"./ant.svg": [
		71314,
		71314
	],
	"./ape.svg": [
		95585,
		95585
	],
	"./apex.svg": [
		74203,
		74203
	],
	"./appc.svg": [
		84887,
		84887
	],
	"./ardr.svg": [
		84280,
		84280
	],
	"./arg.svg": [
		56149,
		56149
	],
	"./ark.svg": [
		37697,
		37697
	],
	"./arn.svg": [
		12316,
		12316
	],
	"./arnx.svg": [
		78604,
		78604
	],
	"./ary.svg": [
		45299,
		45299
	],
	"./asset.svg": [
		42265,
		42265
	],
	"./ast.svg": [
		17849,
		17849
	],
	"./atlas.svg": [
		24268,
		24268
	],
	"./atm.svg": [
		15373,
		15373
	],
	"./atom.svg": [
		36728,
		36728
	],
	"./audr.svg": [
		41575,
		41575
	],
	"./aury.svg": [
		29970,
		29970
	],
	"./auto.svg": [
		61746,
		61746
	],
	"./avax.svg": [
		62893,
		62893
	],
	"./axs.svg": [
		32695,
		32695
	],
	"./aywa.svg": [
		85257,
		85257
	],
	"./bab.svg": [
		42534,
		42534
	],
	"./bake.svg": [
		97696,
		97696
	],
	"./bal.svg": [
		128,
		128
	],
	"./band.svg": [
		41378,
		41378
	],
	"./bar.svg": [
		60470,
		60470
	],
	"./barca.svg": [
		30506,
		30506
	],
	"./bat.svg": [
		62408,
		62408
	],
	"./bay.svg": [
		86429,
		86429
	],
	"./bcbc.svg": [
		1123,
		1123
	],
	"./bcc.svg": [
		60001,
		60001
	],
	"./bcd.svg": [
		51070,
		51070
	],
	"./bch.svg": [
		68042,
		68042
	],
	"./bcio.svg": [
		71942,
		71942
	],
	"./bcn.svg": [
		52820,
		52820
	],
	"./bco.svg": [
		94805,
		94805
	],
	"./bcpt.svg": [
		5810,
		5810
	],
	"./bdl.svg": [
		3783,
		3783
	],
	"./beam.svg": [
		42742,
		42742
	],
	"./bel.svg": [
		49604,
		49604
	],
	"./bela.svg": [
		1261,
		1261
	],
	"./bix.svg": [
		95572,
		95572
	],
	"./blcn.svg": [
		44158,
		44158
	],
	"./blk.svg": [
		35904,
		35904
	],
	"./block.svg": [
		43614,
		43614
	],
	"./blz.svg": [
		29825,
		29825
	],
	"./bnb.svg": [
		75875,
		75875
	],
	"./bnt.svg": [
		76269,
		76269
	],
	"./bnty.svg": [
		942,
		942
	],
	"./booty.svg": [
		72516,
		72516
	],
	"./bos.svg": [
		43717,
		43717
	],
	"./bpt.svg": [
		40347,
		40347
	],
	"./bq.svg": [
		27740,
		27740
	],
	"./brd.svg": [
		10497,
		10497
	],
	"./bsd.svg": [
		6446,
		6446
	],
	"./bsv.svg": [
		14236,
		14236
	],
	"./btc.svg": [
		33216,
		33216
	],
	"./btcd.svg": [
		4780,
		4780
	],
	"./btch.svg": [
		57240,
		57240
	],
	"./btcp.svg": [
		52624,
		52624
	],
	"./btcz.svg": [
		72906,
		72906
	],
	"./btdx.svg": [
		90005,
		90005
	],
	"./btg.svg": [
		67212,
		67212
	],
	"./btm.svg": [
		75622,
		75622
	],
	"./bts.svg": [
		52528,
		52528
	],
	"./btt.svg": [
		69999,
		69999
	],
	"./btx.svg": [
		76859,
		76859
	],
	"./burst.svg": [
		70299,
		70299
	],
	"./busd.svg": [
		12405,
		12405
	],
	"./bze.svg": [
		24024,
		1643
	],
	"./c98.svg": [
		80969,
		80969
	],
	"./cake.svg": [
		79603,
		79603
	],
	"./call.svg": [
		75299,
		75299
	],
	"./cc.svg": [
		58593,
		58593
	],
	"./cdn.svg": [
		11460,
		11460
	],
	"./cdt.svg": [
		11230,
		11230
	],
	"./celo.svg": [
		26812,
		26812
	],
	"./celr.svg": [
		79433,
		79433
	],
	"./cenz.svg": [
		88923,
		88923
	],
	"./chain.svg": [
		27666,
		27666
	],
	"./chat.svg": [
		98761,
		98761
	],
	"./chips.svg": [
		50900,
		50900
	],
	"./chsb.svg": [
		56269,
		56269
	],
	"./chz.svg": [
		19740,
		19740
	],
	"./city.svg": [
		86782,
		86782
	],
	"./cix.svg": [
		43065,
		43065
	],
	"./clam.svg": [
		27684,
		27684
	],
	"./cloak.svg": [
		10705,
		10705
	],
	"./cmm.svg": [
		14112,
		14112
	],
	"./cmt.svg": [
		37177,
		37177
	],
	"./cnd.svg": [
		9616,
		9616
	],
	"./cnx.svg": [
		7268,
		7268
	],
	"./cny.svg": [
		61989,
		61989
	],
	"./cob.svg": [
		89869,
		89869
	],
	"./colx.svg": [
		71209,
		71209
	],
	"./comp.svg": [
		74086,
		74086
	],
	"./coqui.svg": [
		7444,
		7444
	],
	"./coti.svg": [
		16512,
		16512
	],
	"./cred.svg": [
		70971,
		70971
	],
	"./crpt.svg": [
		92716,
		92716
	],
	"./crv.svg": [
		51582,
		51582
	],
	"./crw.svg": [
		14159,
		14159
	],
	"./cs.svg": [
		97745,
		97745
	],
	"./ctk.svg": [
		82585,
		82585
	],
	"./ctr.svg": [
		38560,
		38560
	],
	"./ctsi.svg": [
		33866,
		33866
	],
	"./ctxc.svg": [
		23701,
		23701
	],
	"./cvc.svg": [
		36183,
		36183
	],
	"./d.svg": [
		43505,
		43505
	],
	"./dai.svg": [
		8231,
		8231
	],
	"./dash.svg": [
		58895,
		58895
	],
	"./dat.svg": [
		84866,
		84866
	],
	"./data.svg": [
		10815,
		10815
	],
	"./dbc.svg": [
		60768,
		60768
	],
	"./dcn.svg": [
		36822,
		36822
	],
	"./dcr.svg": [
		69378,
		69378
	],
	"./deez.svg": [
		82183,
		82183
	],
	"./default.svg": [
		41210,
		41210
	],
	"./dent.svg": [
		76464,
		76464
	],
	"./dew.svg": [
		31261,
		31261
	],
	"./dgb.svg": [
		45430,
		45430
	],
	"./dgd.svg": [
		12744,
		12744
	],
	"./dlt.svg": [
		85465,
		85465
	],
	"./dnt.svg": [
		2307,
		2307
	],
	"./dock.svg": [
		99862,
		99862
	],
	"./dodo.svg": [
		49063,
		49063
	],
	"./doge.svg": [
		88996,
		88996
	],
	"./dot.svg": [
		40768,
		40768
	],
	"./drgn.svg": [
		61906,
		61906
	],
	"./drop.svg": [
		75372,
		75372
	],
	"./dta.svg": [
		8204,
		8204
	],
	"./dth.svg": [
		48389,
		48389
	],
	"./dtr.svg": [
		87311,
		87311
	],
	"./ebst.svg": [
		56987,
		56987
	],
	"./eca.svg": [
		12712,
		12712
	],
	"./edg.svg": [
		10987,
		10987
	],
	"./edo.svg": [
		52755,
		52755
	],
	"./edoge.svg": [
		43175,
		43175
	],
	"./egld.svg": [
		48759,
		48759
	],
	"./ela.svg": [
		84269,
		84269
	],
	"./elec.svg": [
		70832,
		70832
	],
	"./elf.svg": [
		9602,
		9602
	],
	"./elix.svg": [
		26487,
		26487
	],
	"./ella.svg": [
		51705,
		51705
	],
	"./emb.svg": [
		57469,
		57469
	],
	"./emc.svg": [
		86844,
		86844
	],
	"./emc2.svg": [
		41254,
		41254
	],
	"./eng.svg": [
		89413,
		89413
	],
	"./enj.svg": [
		94432,
		94432
	],
	"./entrp.svg": [
		1643,
		24024
	],
	"./eon.svg": [
		55171,
		55171
	],
	"./eop.svg": [
		20645,
		20645
	],
	"./eos.svg": [
		88870,
		88870
	],
	"./eqli.svg": [
		99804,
		99804
	],
	"./equa.svg": [
		11155,
		11155
	],
	"./etc.svg": [
		66887,
		66887
	],
	"./eth.svg": [
		77180,
		77180
	],
	"./ethos.svg": [
		15658,
		15658
	],
	"./etn.svg": [
		13874,
		13874
	],
	"./etp.svg": [
		87972,
		87972
	],
	"./eur.svg": [
		62517,
		62517
	],
	"./evx.svg": [
		78922,
		78922
	],
	"./exmo.svg": [
		64496,
		64496
	],
	"./exp.svg": [
		47720,
		47720
	],
	"./fair.svg": [
		32017,
		32017
	],
	"./fct.svg": [
		16650,
		16650
	],
	"./fet.svg": [
		61696,
		61696
	],
	"./fida.svg": [
		88949,
		88949
	],
	"./fil.svg": [
		47604,
		47604
	],
	"./fjc.svg": [
		49114,
		49114
	],
	"./fldc.svg": [
		24498,
		24498
	],
	"./flo.svg": [
		71360,
		71360
	],
	"./floki.svg": [
		61320,
		61320
	],
	"./flux.svg": [
		21982,
		21982
	],
	"./fsn.svg": [
		12144,
		12144
	],
	"./ftc.svg": [
		50140,
		50140
	],
	"./ftm.svg": [
		83562,
		83562
	],
	"./fuel.svg": [
		9191,
		9191
	],
	"./fun.svg": [
		58778,
		58778
	],
	"./gala.svg": [
		36186,
		36186
	],
	"./game.svg": [
		68693,
		68693
	],
	"./gas.svg": [
		5566,
		5566
	],
	"./gbp.svg": [
		41940,
		41940
	],
	"./gbx.svg": [
		23740,
		23740
	],
	"./gbyte.svg": [
		54092,
		54092
	],
	"./generic.svg": [
		8854,
		8854
	],
	"./gin.svg": [
		78371,
		78371
	],
	"./glxt.svg": [
		20302,
		20302
	],
	"./gmr.svg": [
		47059,
		47059
	],
	"./gmt.svg": [
		59085,
		59085
	],
	"./gno.svg": [
		96879,
		96879
	],
	"./gnt.svg": [
		81668,
		81668
	],
	"./gold.svg": [
		7697,
		7697
	],
	"./grc.svg": [
		63911,
		63911
	],
	"./grin.svg": [
		24529,
		24529
	],
	"./grs.svg": [
		11767,
		11767
	],
	"./grt.svg": [
		66840,
		66840
	],
	"./gsc.svg": [
		14756,
		14756
	],
	"./gto.svg": [
		82233,
		82233
	],
	"./gup.svg": [
		9945,
		9945
	],
	"./gusd.svg": [
		91002,
		91002
	],
	"./gvt.svg": [
		3916,
		3916
	],
	"./gxs.svg": [
		36233,
		36233
	],
	"./gzr.svg": [
		33486,
		33486
	],
	"./hight.svg": [
		84297,
		84297
	],
	"./hns.svg": [
		72472,
		72472
	],
	"./hnt.svg": [
		45303,
		45303
	],
	"./hodl.svg": [
		39928,
		39928
	],
	"./hot.svg": [
		44180,
		44180
	],
	"./hpb.svg": [
		84223,
		84223
	],
	"./hsr.svg": [
		5142,
		5142
	],
	"./ht.svg": [
		21907,
		21907
	],
	"./html.svg": [
		18320,
		18320
	],
	"./huc.svg": [
		14221,
		14221
	],
	"./husd.svg": [
		5099,
		5099
	],
	"./hush.svg": [
		57247,
		57247
	],
	"./ibfk.svg": [
		24367,
		24367
	],
	"./icn.svg": [
		70859,
		70859
	],
	"./icp.svg": [
		68541,
		68541
	],
	"./icx.svg": [
		58101,
		58101
	],
	"./idex.svg": [
		90975,
		90975
	],
	"./ignis.svg": [
		22623,
		22623
	],
	"./ilk.svg": [
		20131,
		20131
	],
	"./inj.svg": [
		32252,
		32252
	],
	"./ink.svg": [
		44445,
		44445
	],
	"./ins.svg": [
		95653,
		95653
	],
	"./ion.svg": [
		93639,
		93639
	],
	"./iop.svg": [
		82737,
		82737
	],
	"./iost.svg": [
		94130,
		94130
	],
	"./iota.svg": [
		17654,
		17654
	],
	"./iotx.svg": [
		77663,
		77663
	],
	"./iq.svg": [
		69885,
		69885
	],
	"./irt.svg": [
		83678,
		83678
	],
	"./itc.svg": [
		56579,
		56579
	],
	"./jnt.svg": [
		31669,
		31669
	],
	"./jpy.svg": [
		95110,
		95110
	],
	"./juv.svg": [
		40422,
		40422
	],
	"./kava.svg": [
		90604,
		90604
	],
	"./kcs.svg": [
		31688,
		31688
	],
	"./keep.svg": [
		20680,
		20680
	],
	"./kin.svg": [
		55535,
		55535
	],
	"./klown.svg": [
		70774,
		70774
	],
	"./kmd.svg": [
		94705,
		94705
	],
	"./knc.svg": [
		43447,
		43447
	],
	"./krb.svg": [
		21722,
		21722
	],
	"./ksm.svg": [
		67102,
		67102
	],
	"./lazio.svg": [
		80304,
		80304
	],
	"./lbc.svg": [
		27832,
		27832
	],
	"./lend.svg": [
		60440,
		60440
	],
	"./leo.svg": [
		39277,
		39277
	],
	"./link.svg": [
		18499,
		18499
	],
	"./lkk.svg": [
		86539,
		86539
	],
	"./loom.svg": [
		74876,
		74876
	],
	"./lpt.svg": [
		21277,
		21277
	],
	"./lrc.svg": [
		2760,
		2760
	],
	"./lsk.svg": [
		18259,
		18259
	],
	"./ltc.svg": [
		25638,
		25638
	],
	"./lun.svg": [
		46460,
		46460
	],
	"./luna.svg": [
		32149,
		32149
	],
	"./maid.svg": [
		52165,
		74546
	],
	"./mana.svg": [
		81606,
		81606
	],
	"./mask.svg": [
		56771,
		56771
	],
	"./matic.svg": [
		98375,
		98375
	],
	"./max.svg": [
		27539,
		27539
	],
	"./mcap.svg": [
		74608,
		74608
	],
	"./mco.svg": [
		78150,
		78150
	],
	"./mda.svg": [
		22653,
		22653
	],
	"./mds.svg": [
		96351,
		96351
	],
	"./med.svg": [
		45747,
		45747
	],
	"./meetone.svg": [
		27194,
		27194
	],
	"./mft.svg": [
		10374,
		10374
	],
	"./miota.svg": [
		62657,
		62657
	],
	"./mith.svg": [
		44373,
		44373
	],
	"./mkr.svg": [
		987,
		987
	],
	"./mln.svg": [
		17650,
		17650
	],
	"./mnx.svg": [
		82698,
		82698
	],
	"./mnz.svg": [
		92328,
		92328
	],
	"./moac.svg": [
		36455,
		36455
	],
	"./mod.svg": [
		76161,
		76161
	],
	"./mona.svg": [
		39328,
		39328
	],
	"./msr.svg": [
		46867,
		46867
	],
	"./mth.svg": [
		53828,
		53828
	],
	"./mtl.svg": [
		60792,
		60792
	],
	"./music.svg": [
		44628,
		44628
	],
	"./mzc.svg": [
		97037,
		97037
	],
	"./nano.svg": [
		47709,
		47709
	],
	"./nas.svg": [
		2739,
		2739
	],
	"./nav.svg": [
		69294,
		69294
	],
	"./ncash.svg": [
		95146,
		95146
	],
	"./ndz.svg": [
		95549,
		95549
	],
	"./near.svg": [
		63197,
		63197
	],
	"./nebl.svg": [
		56606,
		56606
	],
	"./neo.svg": [
		34051,
		34051
	],
	"./neos.svg": [
		8810,
		8810
	],
	"./neu.svg": [
		85865,
		85865
	],
	"./nexo.svg": [
		94995,
		94995
	],
	"./ngc.svg": [
		37393,
		37393
	],
	"./nio.svg": [
		85151,
		85151
	],
	"./nkn.svg": [
		61376,
		61376
	],
	"./nlc2.svg": [
		73558,
		73558
	],
	"./nlg.svg": [
		81280,
		81280
	],
	"./nmc.svg": [
		36367,
		36367
	],
	"./nmr.svg": [
		91022,
		91022
	],
	"./npxs.svg": [
		19778,
		19778
	],
	"./ntbc.svg": [
		70636,
		70636
	],
	"./nuls.svg": [
		18083,
		18083
	],
	"./nxs.svg": [
		49320,
		49320
	],
	"./nxt.svg": [
		69127,
		69127
	],
	"./oax.svg": [
		11901,
		11901
	],
	"./ok.svg": [
		74269,
		74269
	],
	"./omg.svg": [
		62630,
		62630
	],
	"./omni.svg": [
		36548,
		36548
	],
	"./one.svg": [
		43645,
		43645
	],
	"./ong.svg": [
		94127,
		94127
	],
	"./ont.svg": [
		7692,
		7692
	],
	"./oot.svg": [
		39631,
		39631
	],
	"./ost.svg": [
		34035,
		34035
	],
	"./ox.svg": [
		33326,
		33326
	],
	"./oxt.svg": [
		85518,
		85518
	],
	"./oxy.svg": [
		48011,
		48011
	],
	"./part.svg": [
		71252,
		71252
	],
	"./pasc.svg": [
		70536,
		70536
	],
	"./pasl.svg": [
		79663,
		79663
	],
	"./pax.svg": [
		18610,
		18610
	],
	"./paxg.svg": [
		35681,
		35681
	],
	"./pay.svg": [
		21923,
		21923
	],
	"./payeer.svg": [
		75313,
		75313
	],
	"./payx.svg": [
		32769,
		32769
	],
	"./pink.svg": [
		12871,
		12871
	],
	"./pirl.svg": [
		44932,
		44932
	],
	"./pivx.svg": [
		53212,
		53212
	],
	"./plr.svg": [
		83115,
		83115
	],
	"./pm-u.svg": [
		78668,
		78668
	],
	"./pm.svg": [
		78754,
		78754
	],
	"./poa.svg": [
		42481,
		42481
	],
	"./poe.svg": [
		13901,
		13901
	],
	"./polis.svg": [
		48300,
		48300
	],
	"./poly.svg": [
		29077,
		29077
	],
	"./porto.svg": [
		35433,
		35433
	],
	"./pot.svg": [
		43324,
		43324
	],
	"./powr.svg": [
		2943,
		2943
	],
	"./ppc.svg": [
		48870,
		48870
	],
	"./ppp.svg": [
		63413,
		63413
	],
	"./ppt.svg": [
		34137,
		34137
	],
	"./pre.svg": [
		51138,
		51138
	],
	"./prl.svg": [
		49291,
		49291
	],
	"./psg.svg": [
		2595,
		2595
	],
	"./pundix.svg": [
		48767,
		48767
	],
	"./pungo.svg": [
		83258,
		83258
	],
	"./pura.svg": [
		989,
		989
	],
	"./qash.svg": [
		15196,
		15196
	],
	"./qiwi.svg": [
		93937,
		93937
	],
	"./qlc.svg": [
		60355,
		60355
	],
	"./qnt.svg": [
		56482,
		56482
	],
	"./qrl.svg": [
		7918,
		7918
	],
	"./qsp.svg": [
		5125,
		5125
	],
	"./qtum.svg": [
		77642,
		77642
	],
	"./r.svg": [
		23375,
		23375
	],
	"./rads.svg": [
		1467,
		1467
	],
	"./rap.svg": [
		71652,
		71652
	],
	"./ray.svg": [
		59725,
		59725
	],
	"./rcn.svg": [
		27620,
		27620
	],
	"./rdd.svg": [
		91807,
		91807
	],
	"./rdn.svg": [
		36677,
		36677
	],
	"./ren.svg": [
		44598,
		44598
	],
	"./rep.svg": [
		84256,
		84256
	],
	"./repv2.svg": [
		976,
		976
	],
	"./req.svg": [
		24817,
		24817
	],
	"./rhoc.svg": [
		34139,
		34139
	],
	"./ric.svg": [
		34639,
		34639
	],
	"./rif.svg": [
		11154,
		11154
	],
	"./rise.svg": [
		65952,
		65952
	],
	"./rlc.svg": [
		78984,
		78984
	],
	"./rose.svg": [
		38658,
		38658
	],
	"./rpx.svg": [
		6303,
		6303
	],
	"./rub.svg": [
		64610,
		64610
	],
	"./rvn.svg": [
		71599,
		71599
	],
	"./ryo.svg": [
		1323,
		1323
	],
	"./safe.svg": [
		48504,
		48504
	],
	"./safemoon.svg": [
		33891,
		33891
	],
	"./sai.svg": [
		4816,
		4816
	],
	"./salt.svg": [
		45147,
		45147
	],
	"./san.svg": [
		22287,
		22287
	],
	"./sand.svg": [
		47585,
		47585
	],
	"./sbd.svg": [
		70220,
		70220
	],
	"./sberbank.svg": [
		71743,
		71743
	],
	"./sc.svg": [
		30385,
		30385
	],
	"./ser.svg": [
		97967,
		97967
	],
	"./shib'.svg": [
		12722,
		12722
	],
	"./shib.svg": [
		88367,
		88367
	],
	"./shift.svg": [
		33045,
		33045
	],
	"./sib.svg": [
		37379,
		37379
	],
	"./sin.svg": [
		52455,
		52455
	],
	"./skl.svg": [
		41279,
		41279
	],
	"./sky.svg": [
		64274,
		64274
	],
	"./slp.svg": [
		12074,
		12074
	],
	"./slr.svg": [
		21704,
		21704
	],
	"./sls.svg": [
		3449,
		3449
	],
	"./smart.svg": [
		41518,
		41518
	],
	"./sngls.svg": [
		71092,
		71092
	],
	"./snm.svg": [
		2953,
		2953
	],
	"./snt.svg": [
		94096,
		94096
	],
	"./snx.svg": [
		26452,
		26452
	],
	"./soc.svg": [
		33148,
		33148
	],
	"./sol.svg": [
		35387,
		35387
	],
	"./spacehbit.svg": [
		22094,
		22094
	],
	"./spank.svg": [
		77594,
		77594
	],
	"./sphtx.svg": [
		74930,
		74930
	],
	"./srn.svg": [
		78934,
		78934
	],
	"./stak.svg": [
		2130,
		2130
	],
	"./start.svg": [
		71309,
		71309
	],
	"./steem.svg": [
		93413,
		93413
	],
	"./storj.svg": [
		67325,
		67325
	],
	"./storm.svg": [
		33394,
		33394
	],
	"./stox.svg": [
		4855,
		4855
	],
	"./stq.svg": [
		46755,
		46755
	],
	"./strat.svg": [
		58639,
		58639
	],
	"./strong.svg": [
		85110,
		85110
	],
	"./stx.svg": [
		79370,
		79370
	],
	"./sub.svg": [
		45711,
		45711
	],
	"./sumo.svg": [
		9727,
		9727
	],
	"./sushi.svg": [
		38879,
		38879
	],
	"./sxp.svg": [
		8470,
		8470
	],
	"./sys.svg": [
		97906,
		97906
	],
	"./taas.svg": [
		20190,
		20190
	],
	"./tau.svg": [
		36163,
		36163
	],
	"./tbx.svg": [
		23595,
		23595
	],
	"./tel.svg": [
		93430,
		93430
	],
	"./ten.svg": [
		92692,
		92692
	],
	"./tern.svg": [
		77478,
		77478
	],
	"./tfuel.svg": [
		10789,
		10789
	],
	"./tgch.svg": [
		16253,
		16253
	],
	"./theta.svg": [
		35257,
		35257
	],
	"./tix.svg": [
		76609,
		98990
	],
	"./tkn.svg": [
		22814,
		22814
	],
	"./tks.svg": [
		13931,
		13931
	],
	"./tnb.svg": [
		35453,
		35453
	],
	"./tnc.svg": [
		45980,
		45980
	],
	"./tnt.svg": [
		21491,
		21491
	],
	"./tomo.svg": [
		97644,
		97644
	],
	"./ton.svg": [
		52282,
		52282
	],
	"./tpay.svg": [
		24113,
		24113
	],
	"./trb.svg": [
		64177,
		64177
	],
	"./trig.svg": [
		345,
		345
	],
	"./trtl.svg": [
		33433,
		33433
	],
	"./trx.svg": [
		67259,
		67259
	],
	"./tusd.svg": [
		91743,
		91743
	],
	"./twt.svg": [
		54072,
		54072
	],
	"./tzc.svg": [
		89640,
		89640
	],
	"./ubq.svg": [
		1279,
		1279
	],
	"./uma.svg": [
		54318,
		54318
	],
	"./uni.svg": [
		12227,
		12227
	],
	"./unity.svg": [
		598,
		598
	],
	"./usd.svg": [
		86357,
		86357
	],
	"./usdc.svg": [
		63276,
		63276
	],
	"./usdt.svg": [
		21635,
		21635
	],
	"./utk.svg": [
		20607,
		20607
	],
	"./uusd.svg": [
		25888,
		25888
	],
	"./veri.svg": [
		4139,
		4139
	],
	"./vet.svg": [
		11184,
		11184
	],
	"./via.svg": [
		86929,
		86929
	],
	"./vib.svg": [
		16034,
		16034
	],
	"./vibe.svg": [
		80851,
		80851
	],
	"./vivo.svg": [
		43749,
		43749
	],
	"./vrc.svg": [
		29794,
		29794
	],
	"./vrsc.svg": [
		52061,
		52061
	],
	"./vtc.svg": [
		69420,
		69420
	],
	"./vtho.svg": [
		3154,
		3154
	],
	"./wabi.svg": [
		10996,
		10996
	],
	"./wan.svg": [
		49467,
		49467
	],
	"./waves.svg": [
		78143,
		78143
	],
	"./wax.svg": [
		47365,
		47365
	],
	"./wbtc.svg": [
		10171,
		10171
	],
	"./wgr.svg": [
		30337,
		30337
	],
	"./wicc.svg": [
		5289,
		5289
	],
	"./wings.svg": [
		31913,
		31913
	],
	"./wpr.svg": [
		76064,
		76064
	],
	"./wtc.svg": [
		55853,
		55853
	],
	"./x.svg": [
		59893,
		59893
	],
	"./xas.svg": [
		80081,
		80081
	],
	"./xbc.svg": [
		76308,
		76308
	],
	"./xbp.svg": [
		95671,
		95671
	],
	"./xby.svg": [
		73998,
		73998
	],
	"./xcp.svg": [
		28724,
		28724
	],
	"./xdn.svg": [
		60399,
		60399
	],
	"./xem.svg": [
		41355,
		41355
	],
	"./xin.svg": [
		89004,
		89004
	],
	"./xlm.svg": [
		19060,
		19060
	],
	"./xmcc.svg": [
		36300,
		36300
	],
	"./xmg.svg": [
		57977,
		57977
	],
	"./xmo.svg": [
		31713,
		31713
	],
	"./xmr.svg": [
		14564,
		14564
	],
	"./xmy.svg": [
		26975,
		26975
	],
	"./xp.svg": [
		23887,
		23887
	],
	"./xpa.svg": [
		4796,
		4796
	],
	"./xpm.svg": [
		9320,
		9320
	],
	"./xpr.svg": [
		60063,
		60063
	],
	"./xrp.svg": [
		39335,
		39335
	],
	"./xsg.svg": [
		63835,
		63835
	],
	"./xtz.svg": [
		11939,
		11939
	],
	"./xuc.svg": [
		61821,
		61821
	],
	"./xvc.svg": [
		22048,
		22048
	],
	"./xvg.svg": [
		8908,
		8908
	],
	"./xzc.svg": [
		23788,
		23788
	],
	"./yfi.svg": [
		95015,
		95015
	],
	"./yoyow.svg": [
		40754,
		40754
	],
	"./zcl.svg": [
		59022,
		59022
	],
	"./zec.svg": [
		84827,
		84827
	],
	"./zel.svg": [
		98940,
		98940
	],
	"./zen.svg": [
		99038,
		99038
	],
	"./zest.svg": [
		30957,
		30957
	],
	"./zil.svg": [
		92928,
		92928
	],
	"./zilla.svg": [
		49389,
		49389
	],
	"./zrx.svg": [
		50461,
		50461
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 45693;
module.exports = webpackAsyncContext;